/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupArtistsResponseArtistsInnerMembersInner } from './LookupArtistsResponseArtistsInnerMembersInner';
import {
    LookupArtistsResponseArtistsInnerMembersInnerFromJSON,
    LookupArtistsResponseArtistsInnerMembersInnerFromJSONTyped,
    LookupArtistsResponseArtistsInnerMembersInnerToJSON,
} from './LookupArtistsResponseArtistsInnerMembersInner';

/**
 * 
 * @export
 * @interface CreateArtistAndLinkRequestEditsInner
 */
export interface CreateArtistAndLinkRequestEditsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateArtistAndLinkRequestEditsInner
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateArtistAndLinkRequestEditsInner
     */
    source: CreateArtistAndLinkRequestEditsInnerSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateArtistAndLinkRequestEditsInner
     */
    stageName: string;
    /**
     * 
     * @type {Array<LookupArtistsResponseArtistsInnerMembersInner>}
     * @memberof CreateArtistAndLinkRequestEditsInner
     */
    members?: Array<LookupArtistsResponseArtistsInnerMembersInner>;
    /**
     * fa (featuring, default) or ofa (other featured)
     * @type {string}
     * @memberof CreateArtistAndLinkRequestEditsInner
     */
    featuredStatus?: CreateArtistAndLinkRequestEditsInnerFeaturedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateArtistAndLinkRequestEditsInner
     */
    op?: CreateArtistAndLinkRequestEditsInnerOpEnum;
}


/**
 * @export
 */
export const CreateArtistAndLinkRequestEditsInnerSourceEnum = {
    Discogs: 'discogs',
    Mb: 'MB',
    Spotify: 'spotify',
    Deezer: 'deezer'
} as const;
export type CreateArtistAndLinkRequestEditsInnerSourceEnum = typeof CreateArtistAndLinkRequestEditsInnerSourceEnum[keyof typeof CreateArtistAndLinkRequestEditsInnerSourceEnum];

/**
 * @export
 */
export const CreateArtistAndLinkRequestEditsInnerFeaturedStatusEnum = {
    Fa: 'fa',
    Ofa: 'ofa'
} as const;
export type CreateArtistAndLinkRequestEditsInnerFeaturedStatusEnum = typeof CreateArtistAndLinkRequestEditsInnerFeaturedStatusEnum[keyof typeof CreateArtistAndLinkRequestEditsInnerFeaturedStatusEnum];

/**
 * @export
 */
export const CreateArtistAndLinkRequestEditsInnerOpEnum = {
    Add: 'add'
} as const;
export type CreateArtistAndLinkRequestEditsInnerOpEnum = typeof CreateArtistAndLinkRequestEditsInnerOpEnum[keyof typeof CreateArtistAndLinkRequestEditsInnerOpEnum];


/**
 * Check if a given object implements the CreateArtistAndLinkRequestEditsInner interface.
 */
export function instanceOfCreateArtistAndLinkRequestEditsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "stageName" in value;

    return isInstance;
}

export function CreateArtistAndLinkRequestEditsInnerFromJSON(json: any): CreateArtistAndLinkRequestEditsInner {
    return CreateArtistAndLinkRequestEditsInnerFromJSONTyped(json, false);
}

export function CreateArtistAndLinkRequestEditsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateArtistAndLinkRequestEditsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceId': !exists(json, 'source_id') ? undefined : json['source_id'],
        'source': json['source'],
        'stageName': json['stageName'],
        'members': !exists(json, 'members') ? undefined : ((json['members'] as Array<any>).map(LookupArtistsResponseArtistsInnerMembersInnerFromJSON)),
        'featuredStatus': !exists(json, 'featuredStatus') ? undefined : json['featuredStatus'],
        'op': !exists(json, 'op') ? undefined : json['op'],
    };
}

export function CreateArtistAndLinkRequestEditsInnerToJSON(value?: CreateArtistAndLinkRequestEditsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_id': value.sourceId,
        'source': value.source,
        'stageName': value.stageName,
        'members': value.members === undefined ? undefined : ((value.members as Array<any>).map(LookupArtistsResponseArtistsInnerMembersInnerToJSON)),
        'featuredStatus': value.featuredStatus,
        'op': value.op,
    };
}

